import * as React from "react";
import { SVGProps } from "react";
function SvgVolumeMaxIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 8.77v6h4l5 5v-16l-5 5H3Zm13.5 3A4.5 4.5 0 0 0 14 7.74v8.05c1.48-.73 2.5-2.25 2.5-4.02ZM14 3v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgVolumeMaxIcon;
